import axios from "axios";
import { API_URL } from "const/constants";

/** Email selected admission documents (presigned links / permanent links / attachments). */
export const sendAdmissionDocumentsEmail = (studentId, payload) =>
  axios.post(`${API_URL}/student/${studentId}/documents/email`, payload).then((r) => r.data);

/** Org email templates (reused from the marketing-email feature) for seeding subject/body. */
export const fetchEmailTemplates = () =>
  axios.get(`${API_URL}/email-templates`).then((r) => r.data?.data ?? r.data ?? []);

/** Permanent share links of an admission (with revoked / document-present flags). */
export const fetchDocumentShareLinks = (studentId) =>
  axios
    .get(`${API_URL}/student/${studentId}/documents/share-links`)
    .then((r) => r.data?.data ?? []);

/** Revoke (revoked=true) or re-enable (revoked=false) a permanent share link. */
export const setDocumentShareLinkRevoked = (studentId, tokenId, revoked) =>
  axios
    .patch(`${API_URL}/student/${studentId}/documents/share-links/${tokenId}`, { revoked })
    .then((r) => r.data);

/** Regenerate a permanent share link for one admission. */
export const regenerateDocumentShareLink = (studentId, tokenId, revokeOld) =>
  axios
    .post(`${API_URL}/student/${studentId}/documents/share-links/${tokenId}/regenerate`, {
      revokeOld,
    })
    .then((r) => r.data?.data ?? r.data);

/** Org-wide paged list for the maintenance page. */
export const fetchAllDocumentShareLinks = ({ page = 0, size = 20, search, status } = {}) =>
  axios
    .get(`${API_URL}/document-share-links`, { params: { page, size, search, status } })
    .then((r) => r.data?.data ?? r.data);

/** Send history for one share token. */
export const fetchDocumentShareLinkSends = (tokenId) =>
  axios.get(`${API_URL}/document-share-links/${tokenId}/sends`).then((r) => r.data?.data ?? []);

/** Org-wide revoke/re-enable. */
export const setAnyDocumentShareLinkRevoked = (tokenId, revoked) =>
  axios.patch(`${API_URL}/document-share-links/${tokenId}`, { revoked }).then((r) => r.data);

/** Org-wide regenerate. */
export const regenerateAnyDocumentShareLink = (tokenId, revokeOld) =>
  axios
    .post(`${API_URL}/document-share-links/${tokenId}/regenerate`, { revokeOld })
    .then((r) => r.data?.data ?? r.data);
